import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpfileinfo" id="xmpfileinfo"></a>
    <h1 {...{
      "id": "xmpfileinfo"
    }}>{`XMPFileInfo`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0
This object is returned by `}<a parentName="p" {...{
        "href": "./XMPFile.md#getfileinfo"
      }}>{`XMPFile.getFileInfo`}</a>{`. The read-only properties describe the file represented by the `}<a parentName="p" {...{
        "href": "./XMPFile.md"
      }}>{`XMPFile object`}</a>{`.  `}</p>
    <a name="xmpfileinfo-filepath" id="xmpfileinfo-filepath"></a>
    <h2 {...{
      "id": "filepath--string"
    }}>{`filePath : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The absolute path of the file, in JavaScript notation.`}</p>
    <a name="xmpfileinfo-format" id="xmpfileinfo-format"></a>
    <h2 {...{
      "id": "format--number"
    }}>{`format : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
One of the file-format constants. See `}<a parentName="p" {...{
        "href": "./XMPConst.md#file-format-numeric-constants"
      }}>{`File format numeric constants`}</a>{`.`}</p>
    <a name="xmpfileinfo-handlerflags" id="xmpfileinfo-handlerflags"></a>
    <h2 {...{
      "id": "handlerflags--number"
    }}>{`handlerFlags : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The features that are supported for this format. A logical OR of these bit-flag constants:`}<br></br>{`                 - XMPConst.HANDLER_CAN_INJECT_XMP - Can inject first-time XMP into an existing file.`}<br></br>{`                 - XMPConst.HANDLER_CAN_EXPAND - Can expand XMP or other metadata in an existing file.`}<br></br>{`                 - XMPConst.HANDLER_CAN_REWRITE - Can copy one file to another, writing new metadata.`}<br></br>{`                 - XMPConst.HANDLER_PPEFERS_IN_PLACE - Can expand, but prefers in-place update. `}<br></br>{`                 - XMPConst.HANDLER_CAN_RECONCILE - Supports reconciliation between XMP and other forms.`}<br></br>{`                 - XMPConst.HANDLER_ALLOWS_ONLY_XMP - Allows access to just the XMP, ignoring other forms.`}<br></br>{`                 - XMPConst.HANDLER_RETURNS_RAW_PACKETS - File handler returns raw XMP packet information.`}<br></br>{`                 - XMPConst.HANDLER_RETURNS_TNAIL - File handler returns native thumbnail.`}<br></br>{`                 - XMPConst.HANDLER_OWNS_FILE - File handler does the file open and close.`}<br></br>{`                 - XMPConst.HANDLER_ALLOWS_SAFE_UPDATE - File handler allows crash-safe file updates.`}<br></br></p>
    <a name="xmpfileinfo-openflags" id="xmpfileinfo-openflags"></a>
    <h2 {...{
      "id": "openflags--number"
    }}>{`openFlags : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The options with which this file was opened. One of these constants:`}<br></br>{`                 - XMPConst.OPEN_FOR_READ - Open for read-only access.`}<br></br>{`                 - XMPConst.OPEN_FOR_UPDATE - Open for reading and writing.`}<br></br>{`                 - XMPConst.OPEN_ONLY_XMP - Only the XMP is wanted, allows space/time optimizations.`}<br></br>{`                 - XMPConst.OPEN_STRICTLY - Be strict about locating XMP and reconciling with other forms.`}<br></br>{`                 - XMPConst.OPEN_USE_SMART_HANDLER - Require the use of a smart handler. No packet scanning is performed.`}<br></br>{`                 - XMPConst.OPEN_USE_PACKET_SCANNING - Force packet scanning, do not use a smart handler.`}<br></br>{`                 - XMPConst.OPEN_LIMITED_SCANNING - Only packet-scan files known to need scanning.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      